















































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator'
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import {FieldType,Filter,CompareType} from '../../../store/entities/filter'
import PageRequest from '../../../store/entities/page-request'
import CreateRole from './create-role.vue'
import EditRole from './edit-role.vue'
import EditMember from './editMember.vue'
import quickEntry from './quickEntry.vue'
import ajax from '@/lib/ajax'
import userAjax from '@/lib/userAjax'
@Component({
    components:{CreateRole,EditRole,EditMember,quickEntry}
})
export default class Roles extends AbpBase{
    edit(){
        this.editModalShow=true;
    }
    roleTypes:any=[];
    filters:Filter[]=[
        {Type:FieldType.String,Value:'',FieldName:'Name',CompareType:CompareType.Contains},
        {Type:FieldType.String,Value:'',FieldName:'DisplayName',CompareType:CompareType.Contains},
        {Type:FieldType.DataRange,Value:'',FieldName:'Description',CompareType:CompareType.Contains}
    ]
    createModalShow:boolean=false;
    editModalShow:boolean=false;
    editMemberShow:boolean=false;
    quickEntryShow:boolean=false;
    get list(){
        return this.$store.state.role.list;
    };
    get loading(){
        return this.$store.state.role.loading;
    }
    create(){
        this.createModalShow=true;
        this.getPermission();
        this.roleMenu =[]
    }
    
    async getRoleType() {
        let rep = await ajax.get('/api/services/app/AbpDataDict/GetList', {
            params: {
                filter: 'itemType=="RoleType"'
            }
        })
        this.roleTypes = rep.data.result.items
        return rep.data.result.items
    }
    pageChange(page:number){
        this.$store.commit('role/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('role/setPageSize',pagesize);
        this.getpage();
    }
    async getpage(){
        let where= Util.buildFilters(this.filters);
        let pagerequest=new PageRequest();
        pagerequest.maxResultCount=this.pageSize;
        pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        pagerequest.where=where;
        await this.$store.dispatch({
            type:'role/getAll',
            data:pagerequest
        })
    }
    get pageSize(){
        return this.$store.state.role.pageSize;
    }
    get totalCount(){
        return this.$store.state.role.totalCount;
    }
    get currentPage(){
        return this.$store.state.role.currentPage;
    }
    //
    roleMenu:any = []
    roleId:any = 0
    guids:any = []
    tree:any = []
    type_name:any = ''
    role_list:any = []
    report_list:any = []
    currentRole:any = {}
    $refs: {quickEntry: HTMLFormElement}
    columns=[{
        title:'角色名',
        key:'name',
        width: 150,
    },{
        title:'显示名',
        key:'displayName',
        width: 150,
    },{
        title: '分组',
        width: 100,
        render: (h:any, params:any) => {
            let type = ''
            // 获取不到 this.roleTypes
            let roleTypes = [
                {itemCode: '1', itemName: '区域'},
                {itemCode: '2', itemName: '总部'},
                {itemCode: '0', itemName: '个人'},
            ]
            
            roleTypes.forEach((item:any) => {
                if (item.itemCode == params.row.roleType) {
                    type = item.itemName
                }
            })
            return h('span', type)
        }
    },{
        title:'描述',
        key:'description'
    },{
        title:this.L('IsEdit'),
        width: 80,
        align: 'center',
        render:(h:any,params:any)=>{
            return h('span',params.row.allowLowEdit?'是':'否')
        }
    },{
        title:this.L('IsStatic'),
        width: 80,
        align: 'center',
        render:(h:any,params:any)=>{
            return h('span',params.row.isStatic?'是':'否')
        }
    },{
        title:'操作',
        key:'Actions',
        align: 'center',
        width:300,
        render:(h:any,params:any)=>{
            return h('div',[
                h('Button',{
                    props:{
                        type:'primary',
                        size:'small'
                    },
                    style:{
                        marginRight:'5px'
                    },
                    on:{
                        click:async ()=>{
                            this.$store.commit('role/edit',params.row);
                            this.edit();
                            this.getmenu(params)
                        }
                    }
                },'编辑'),
                h('Button',{
                    props:{
                        type:'error',
                        size:'small'
                    },
                    style: {
                        marginRight: '5px'
                    },
                    on:{
                        click:async ()=>{
                            this.$Modal.confirm({
                                    title:'提示',
                                    content:'是否删除此角色',
                                    okText:'是',
                                    cancelText:'否',
                                    onOk:async()=>{
                                        await this.$store.dispatch({
                                            type:'role/delete',
                                            data:params.row
                                        })
                                        await this.getpage();
                                    }
                            })
                        }
                    }
                },'删除'),
                h('Button', {
                    props: {
                        type: 'primary',
                        size: 'small'
                    },
                    style: {
                        marginRight: '5px'
                    },
                    on: {
                        click:() => {
                            this.getrole(params)
                        }
                    }
                }, '角色人员'),
                h('Button', {
                    props: {
                        type: 'primary',
                        size: 'small'
                    },
                    on: {
                        click:() => {
                            this.getReport(params)
                        }
                    }
                }, '快速入口')
            ])
        }
    }]
    //角色菜单添加开始
    async getmenu(params:any){
        let rep = await ajax.get("/api/services/app/AbpMenu/GetAllListByRole",{
                params:{
                        role_id:this.list[params.index].id
                    }
                });
                if(rep.data.success){
                    this.roleMenu=rep.data.result.items;
                    this.getPermission();
                }
                this.roleId=this.list[params.index].id;
                this.guids=[];
                //this.modal1=true;
    }
    async getPermission(){
        let rep =await ajax.get("/api/services/app/AbpMenu/GetAllListByTenant");
        if(rep.data.success){
            this.tree=this.getJsonTree(rep.data.result.items,null);
        }
    }
    getJsonTree(data:any, parentId:any){
        let itemArr = [];
        for (let i = 0; i < data.length; i++) {
            let node = data[i];
            if (node.parentId === parentId) {
                let newNode:any = {
                    id: '',
                    menuName: '',
                    parentId: '',
                    displayName: '',
                    permissionName: '',
                    icon: '',
                    sort: '',
                    url: '',
                    title: '',
                    expand: false,
                    checked: false,
                    children: []
                };
                newNode.id = node.id;
                newNode.menuName = node.name;
                newNode.parentId = node.parentId;
                newNode.displayName = node.displayName;
                newNode.permissionName = node.permissionName,
                newNode.icon = node.icon;
                newNode.sort = node.sort;
                newNode.url = node.url;
                newNode.title=node.displayName;
                newNode.expand = true;
                for(let i=0;i<this.roleMenu.length;i++){
                    if(node.id===this.roleMenu[i]){
                        newNode.checked = true;
                    }
                }
                if(node.parentId==null){
                    newNode.checked = false;
                }
                newNode.children = this.getJsonTree(data, node.id);
                itemArr.push(newNode);
            }
        }
        return itemArr;
    }
    async confilm(val:any){
        val.forEach((obj:any)=>{
            this.guids.push(obj.id);
        });
        let rep = await ajax.put(`/api/services/app/AbpMenu/UpdateRoleMenus?role_id=${this.roleId}` ,this.guids);
        if(rep.data.success){
            this.$Message.success("修改成功");
        }
    }
    async cre_con(val:any,id:any){
        val.forEach((obj:any)=>{
            this.guids.push(obj.id);
        });
        let rep = await ajax.put(`/api/services/app/AbpMenu/UpdateRoleMenus?role_id=`+id ,this.guids);
        if(rep.data.success){
            this.$Message.success("新增成功");
        }
    }
    //结束
    async created(){
        await this.getRoleType()
        this.getpage()
        await this.$store.dispatch({
            type:'role/getAllPermissions'
        })
    }
    async getrole(param:any){
        this.currentRole = param.row
        this.editMemberShow = true
        this.type_name = param.row.normalizedName
        let role_list = await userAjax.get('/api/services/app/User/GetUserListByRole?roleId='+param.row.id)
        this.role_list = role_list.data.result.items
    }
    change_show(){
        this.editMemberShow = false
        this.quickEntryShow = false
    }
    async getReport(param:any) {
        this.quickEntryShow = true
        let report_list = await ajax.get('/api/services/app/AbpReportSysSetting/GetPaged')
        this.report_list = report_list.data.result.items
        this.roleId = param.row.id
        this.$refs.quickEntry.selected(this.roleId)
    }
}
